<template>
  <Container>
    <div class="row">
      <div class="col-md-9">
        <div v-if="state === 'success'">
          <PrismicRichText :field="document.data.content" />
          <br />
        </div>
      </div>
      <div class="col-md-3">
        <ReisethemenMenu />
      </div>
    </div>
  </Container>
</template>



<script>

import { useDocumentByUID } from "@/composables/useDocumentByUID";
import { onMounted } from 'vue'
import Container from '@/components/Container.vue'
import ReisethemenMenu from '@/components/ReisethemenMenu.vue'
import { usePageMeta } from '@/composables/usePageMeta'

export default {
  name: 'Impressum',
  components: {
    Container,
    ReisethemenMenu,
  }, 
  setup() {  

    onMounted(() => { 
      window.scrollTo(0, 0);
    });

    const { data: document, state } = useDocumentByUID("page", "home");
    usePageMeta(state, document)   
  

    return {
      document,
      state
    }

  }
}
</script>